import { makeStyles } from 'tss-react/mui';
import { theme } from '../theme';

/**
 * Custom hook that defines the styles for the loading screen component.
 */
const useLoadingScreenStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh - 64px)',
    backgroundColor: theme.background.light,
  },
  loadingText: {
    fontFamily: theme.fontFamily,
    marginTop: theme.margin.l,
    fontSize: theme.fontSize.default,
    fontWeight: theme.fontWeight.medium,
    alignText: 'center',
  },
}));

export default useLoadingScreenStyles;
